<template>
	<div class="divider"/>
</template>

<script>

export default {
	name: 'BaseDivider',
}

</script>

<style scoped>

.divider {
	width: 100%;
	height: 1px;
	background: #E7E7EF;
}

</style>
